import React, { useEffect, useState } from "react";
import Testimonial_1 from "../../images/Marco-Stigler-Thomas.jpg";
import Testimonial_2 from "../../images/testimonial_3.JPG";
import Testimonial_3 from "../../images/photo-1627161683077-e34782c24d81.jpg";
import Testimonial_4 from "../../images/istockphoto-1450406906-612x612.jpg";

const testimonials = [
  {
    id: 1,
    img: Testimonial_1,
    name: "Emily Carter",
    designation: "Marketing Director",
    text: "Working with this team completely transformed our online presence. Their creative strategies and attention to detail helped us boost engagement by over 60% in just three months!",
  },
  {
    id: 2,
    img: Testimonial_2,
    name: "Jason Miller",
    designation: "Founder & CEO",
    text: "They understood our brand voice perfectly and delivered stunning results. The level of professionalism and communication was top-notch from start to finish.",
  },
  {
    id: 3,
    img: Testimonial_3,
    name: "Sarah Johnson",
    designation: "Senior Brand Manager",
    text: "Their design and marketing expertise is unmatched. Our conversion rates improved significantly after their revamp. Highly recommend them to any growing brand.",
  },
  {
    id: 4,
    img: Testimonial_4,
    name: "David Brown",
    designation: "Head of Digital Strategy",
    text: "From concept to execution, they delivered beyond expectations. The results speak for themselves — our traffic and leads doubled in a matter of weeks.",
  },
];

const Testimonial = () => {
  const [current, setCurrent] = useState(0);
  const length = testimonials.length;

  // Auto-slide every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % length);
    }, 4000);
    return () => clearInterval(interval);
  }, [length]);

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % length);
  };

  const prevSlide = () => {
    setCurrent((prev) => (prev - 1 + length) % length);
  };

  return (
    <section className="testimonial-section">
      <h5 style={{ color: "#0A184A", textAlign: "center" }}>Our Testimonials</h5>

      <h1
        style={{
          fontWeight: "bold",
          color: "#0A184A",
          textAlign: "center",
        }}
      >
        Innovative Solutions, <br /> Flawlessly Executed
      </h1>

      <p style={{ color: "#0A184A", textAlign: "center" }}>
        We combine creativity and meticulous attention to detail to deliver
        designs and solutions that not only look stunning but also perform
        flawlessly. Every project is crafted to make a lasting impact and
        elevate your brand’s presence.
      </p>

      <div className="carousel">
        {testimonials.map((t, index) => {
          let className = "carousel-card";
          if (index === current) className += " active";
          else if (index === (current + 1) % length) className += " next";
          else if (index === (current - 1 + length) % length) className += " prev";
          else className += " hidden";

          return (
            <div key={t.id} className={className}>
              <img
                src={t.img}
                alt={t.name}
                className="carousel-img"
                style={{
                  width: "120px",
                  height: "120px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  margin: "0 auto",
                }}
              />
              <p
                className="carousel-feedback"
                style={{
                  fontStyle: "italic",
                  color: "#333",
                  textAlign: "center",
                  marginTop: "15px",
                }}
              >
                "{t.text}"
              </p>
              <h3
                className="carousel-name"
                style={{
                  textAlign: "center",
                  color: "#0A184A",
                  marginTop: "10px",
                  fontWeight: "bold",
                }}
              >
                {t.name}
              </h3>
              <span
                className="carousel-role"
                style={{
                  display: "block",
                  textAlign: "center",
                  color: "#555",
                  fontSize: "14px",
                }}
              >
                {t.designation}
              </span>
            </div>
          );
        })}
      </div>

      {/* Buttons at the bottom */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "20px",
          gap: "20px",
        }}
      >
        <button
          onClick={prevSlide}
          style={{
            backgroundColor: "#0A184A",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            padding: "10px 20px",
            cursor: "pointer",
            fontSize: "18px",
            transition: "0.3s",
          }}
          onMouseOver={(e) =>
            (e.currentTarget.style.backgroundColor = "#06103a")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.backgroundColor = "#0A184A")
          }
        >
          &#10094;
        </button>
        <button
          onClick={nextSlide}
          style={{
            backgroundColor: "#0A184A",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            padding: "10px 20px",
            cursor: "pointer",
            fontSize: "18px",
            transition: "0.3s",
          }}
          onMouseOver={(e) =>
            (e.currentTarget.style.backgroundColor = "#06103a")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.backgroundColor = "#0A184A")
          }
        >
          &#10095;
        </button>
      </div>
    </section>
  );
};

export default Testimonial;
